"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencySymbols = void 0;
exports.currencySymbols = {
    EUR: '€',
    USD: '$',
    USDT: '₮',
    BTC: '₿',
    ETH: 'Ξ',
    XRP: '✕',
    SOL: '◎',
    ADA: '₳',
    DOGE: 'Ð',
    TRX: 'Τ',
    UAH: '₴',
    PLN: 'zł',
    CZK: 'Kč',
    HUF: 'Ft',
    RON: 'lei',
    BGN: 'лв',
    HRK: 'kn',
    CHF: '₣',
    GBP: '£',
    DKK: 'kr',
    NOK: 'kr',
    ISK: 'kr',
    TRY: '₺',
    AED: 'د.إ',
    SAR: '﷼',
    QAR: '﷼',
    EGP: '£',
    ZAR: 'R',
    INR: '₹',
    IDR: 'Rp',
    MYR: 'RM',
    PHP: '₱',
    THB: '฿',
    VND: '₫',
    CNY: '¥',
    JPY: '¥',
    KRW: '₩',
    KZT: '₸',
    BYN: 'Br',
    RUB: '₽',
    ARS: '$',
    BRL: 'R$',
    MXN: '$',
    CLP: '$',
    COP: '$',
    CAD: '$',
    AUD: '$',
    NZD: '$',
    SGD: '$',
    HKD: '$',
    TWD: 'NT$',
    NGN: '₦',
    GHS: '₵',
    KES: 'Sh',
    PKR: '₨',
    LKR: 'Rs',
    BDT: '৳',
    ILS: '₪',
    AZN: '₼',
    GEL: '₾',
    AMD: '֏',
    TJS: 'ЅМ',
    KGS: '⃀',
    MNT: '₮',
    LAK: '₭',
    MMK: 'K',
};
